module.exports = __webpack_public_path__ + "img/comparison-product-brand.3f9bea9f.png";